import { get, keys } from 'lodash'

const HiddenFields = () => {
	const hiddenFields = {
		redirect_url: get(window, 'hubConnectorVars.login.redirect_url', ''),
		domain: get(window, 'hubConnectorVars.login.domain', ''),
		auth_nonce: get(window, 'hubConnectorVars.login.auth_nonce', ''),
	}

	return (
		<>
			{keys(hiddenFields).map(key =>
				<input
					key={key}
					type="hidden"
					name={key}
					value={get(hiddenFields, key, '')}
				/>
			)}
		</>
	)
}

export default HiddenFields
